module.exports = __webpack_public_path__ + "static/media/pastasarrocesy_checked.0c7a9e4b.svg";